








import { Component, Vue } from 'vue-property-decorator';

declare const daum: any;

@Component({})
export default class Location extends Vue {
  private mounted() {
    const map = new daum.maps.Map(this.$refs.map, {
      center: new daum.maps.LatLng(37.506168, 127.063924),
      level: 3
    });

    new daum.maps.Marker({
      position: new daum.maps.LatLng(37.506168, 127.063924)
    }).setMap(map);
  }
}
